(function(algolia) {
    'use strict';
    const render = algolia.externals.render;
    // This is used in all templates to display safe HTML
    // window.htmPreact.html
    const html = algolia.externals.html;
  
    var algoliasearch = algolia.externals.algoliasearch;
    algolia.searchClient = algoliasearch(
            algolia.config.app_id,
            algolia.config.search_api_key
    );

    algolia.render = (template, container, data) => {
      // window.htmPreact.render
      return render(template(html, data), container);
    };
  
    var formatPrice = function formatPrice(value) {
      return algolia.formatMoney(Number(value) * 100).replace('.00','');
    };

    var isNewProduct = function isNewProduct(publishedDate){
      if(publishedDate === undefined){
        return false;
      }
      let currentDate = new Date().getTime();
      let time_diff = currentDate - publishedDate*1000;//first_published_unix is in seconds,multiply 1000 to match Date() milisecond format
      let day_diff = time_diff / (1000 * 3600 * 24);
      if(day_diff<60){
        return true;
      } else {
        return false;
      }
    }

  
    var escapeHtml = function escapeHtml(unsafe) {
      return (unsafe || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    };
  
    algolia.helpers = {
      formatNumber: function formatNumber(val) {
        return Number(val).toLocaleString();
      },
      displayBadge: function displayBadge(item){
        let metafields = item.meta?.display;
        let isNew = isNewProduct(item.meta?.search?.first_published_at_unix) 
        if(item.inventory_quantity == 0){
          return 'Waitlist'
        } else if(metafields?.one_of_a_kind && metafields.one_of_a_kind.toString().toLowerCase()==="true"){//String
          return 'One-of-a-kind'
        }else if(isNew) {
          return 'New'
        }else if(metafields?.exclusive && metafields.exclusive.toString().toLowerCase()==="true"){
          return 'Exclusive'
        }else if(metafields?.bestseller && metafields.bestseller.toString().toLowerCase()==="true"){
          return 'Bestseller'
        }else if(metafields?.buyers_pick && metafields.buyers_pick.toString().toLowerCase()==="true"){
          return "Buyer's Pick"
        }
        return false
      },
      //1. Non Distinct or distinct with ONLY ONE variant- display single price and use available data
      //2. Distinct w/o options - display range and use available data
      //3. Distinct w/ options - display single price by default, get range data with api later
      displayPrice: function displayPrice(item, distinct, useFromLabel) {
        if (!distinct || item.variants_count == 1) {
          return formatPrice(item.price);
        }else {
          let max = item.variants_max_price;
          let min = item.variants_min_price;
          let isRange = Number(min) && Number(max)>Number(min)
          if (isRange && useFromLabel) {
            return `From ${formatPrice(min)}`;
          }
          return isRange ? `${formatPrice(min)} - ${formatPrice(max)}` : formatPrice(max);
        }//if distinct product card is grouped by option and product has more than one variant, price range will be displayed later after requesting for a non distinct hit in instant_search.js
      },
      displayStrikedPrice: function displayStrikedPrice(hit, distinct, useFromLabel) {
        if(!distinct || hit.variants_count == 1 ){//display single price
          return formatPrice(hit.compare_at_price)
        }else{
          let min=hit.variants_compare_at_price_min
          let max=hit.variants_compare_at_price_max
          let isRange = Number(min) && Number(max)>Number(min)
          if (isRange && useFromLabel) {
            return formatPrice(min);
          }
          return isRange ? `${formatPrice(min)} - ${formatPrice(max)}`:formatPrice(hit.compare_at_price)
        }
      },
      displayDiscount: function displayDiscount(hit) {
        let promo_message_2 = hit.named_tags.promo_message_2;

        if(typeof promo_message_2 !== 'undefined'){
          return algolia.helpers.displayPromoMessage(hit, 2)
        }else{
          const comparing = Number(hit.compare_at_price) && Number(hit.compare_at_price) > Number(hit.price);
          const discount_ratio = Number(1.0 - hit.price_ratio)?.toFixed(1);
          
          if (comparing){ 
            const productPrice = Math.trunc(hit.price * 100)
            const compareAtPrice = Math.trunc(hit.compare_at_price * 100)
            let discountPercentage = window.LG_custom.getDiscountPercent(productPrice, compareAtPrice ,null);
            return discountPercentage ? `${discountPercentage}% OFF`:`${Math.floor(discount_ratio * 100)}% OFF`
          }
          else{
            return null
          }
        }
      },
      displayPromoMessage: function displayPromoMessage(item, num = 1) {
        let firstMessage = undefined;
        let secondMessage = undefined;
        let promo_message = item.named_tags[`promo_message_${num}`];
        const isMultipleMsgs = promo_message && promo_message.includes('|');

        if(promo_message && isMultipleMsgs){
          firstMessage = promo_message.split('|')[0].trim();
          secondMessage = promo_message.split('|')[1].trim();
        }

        if(typeof promo_message !== 'undefined' && !isMultipleMsgs){
          return promo_message
        } else {
          return html`<section class="promoMessage1_first mb-2">${firstMessage}</section>
          <section class="promoMessage1_second mb-2">${secondMessage}</section>`
        }
      },
      instantsearchLink: function instantsearchLink(hit) {
        const addVariantId = !hit._distinct && hit.objectID !== hit.id;
        return (
          algolia.base_url +
          '/products/' +
          hit.handle +
          (addVariantId ? '?variant=' + hit.objectID : '')
        );
      },
      fullTitle: function fullTitle(title, distinct, variant_title) {
        var res = title;
        if (
          !distinct &&
          variant_title &&
          variant_title !== 'Default Title' &&
          variant_title !== 'Default'
        ) {
          res += ' (' + variant_title + ')';
        }
  
        return escapeHtml(res);
      },
      variantTitleAddition: function variantTitleAddition(item, distinct) {
        let res = ' ';
        if ( distinct &&
          item.variant_title &&
          item.variant_title !== 'Default Title' &&
          item.variant_title !== 'Default'
        ) { 
          res+= distinct.includes('_') ? `- ${distinct.split(/_(.*)/)[1].replace(/[-_]/g,' ')}`: '';
        }
        return res;
      },
      hexToRGB: function hexToRGB(hex){
        if (!hex) return ``;
        if(hex.length== 4){
          hex = hex.substring(1).replace(/./g, '$&$&')
        }
        var m = hex.match(/^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i);
        return `${parseInt(m[1], 16)},${parseInt(m[2], 16)},${parseInt(m[3], 16)}`;
      },
      sizedImage: function sizedImage(sizeInput, item, _distinct) {
        // SHOP-405: ignoring distinct here since we aren't using algolia out of the box for distinct
        var image = item.image ? item.image : item.product_image;
        if (!image) {
          return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        }
        var size = sizeInput.replace(/^\s+|\s+$/g, ''); // Render and trim
        if (size === 'original') {
          return image;
        }
        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
      },
      templateSetup: function templateSetup(hit) {
        let isDistinct =
          hit.meta?.search?.distinct_key === undefined
            ? null
            : hit.meta.search.distinct_key;
        let isOnSale = hit.meta?.search?.on_sale === true || hit.tags.includes('on_sale');
        let discount_style = isOnSale
          ? 'text-red-600 ais-discounted-price'
          : '';
        const badge = algolia.helpers.displayBadge(hit);
        const badge_style = badge ? 'plp-product-badge' : 'hidden';
        let hasMoreOptions = hit.tags.includes('plusmore');

        return {
          isDistinct,
          isOnSale,
          discount_style,
          badge_style,
          hasMoreOptions
        }
      },
    };
  
    [
      'pico',
      'icon',
      'thumb',
      'small',
      'compact',
      'medium',
      'large',
      'grande',
      'original'
    ].forEach(function(size) {
      algolia.helpers[size + 'Image'] = function(item) {
          var image = item.distinct ? item.product_image : item.image;
  
          if (!image) {
            return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
          }
  
          if (size === 'original') {
            return image;
          }
  
          return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
      };
    });
  })(window.algoliaShopify);
  